import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5661%3A7240
 *
 * @param {SvgIconProps} props - svg props
 */
export const RestartIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C10.6686 6 9.43844 6.43368 8.44313 7.16748L7.87205 6.05243C7.87205 6.05243 6.66671 7.33346 6.25881 9.70252C6.25881 9.70252 7.82976 10.1051 9.99675 10.201L9.37315 8.98338C10.0759 8.37092 10.9946 8 12 8C14.2092 8 16 9.79086 16 12C16 14.2091 14.2092 16 12 16C9.86512 16 8.12085 14.3275 8.00604 12.2212L6.02502 12.5514C6.30339 15.6066 8.87221 18 12 18Z' fill={color}/>
        </SvgIcon>
    )
}

export default RestartIcon
